import React, { useState} from "react"
import { useForm } from "react-hook-form"
import { FormType } from "../../types"
import { trimmedGaCookieValue } from "../../../utils/look-up-ga-cookie"
import persistQueryParams from "../../../utils/persist-query-params"
import BrandedHybridLeadForm from "./branded-hybrid-lead-form"

type FormProps = {
  form: FormType
  [key: string]: any
}

const StraightToModalForm = ({ form, ...props }: FormProps) => {
  const { register, handleSubmit, formState: { errors } } = useForm()
  const [isModalOpen, setIsModalOpen] = useState(false) // State for modal visibility

  const onSubmit = (data: FormData) => {
    // GA event logging
    if (typeof marketingDataLayer !== `undefined`) {
      marketingDataLayer?.push({
        event: `gaForm`,
        eventCategory: `Form`,
        eventAction: `zip-form`,
        eventLabel: location.pathname
      });
    }

    // Tealium event logging
    if (typeof utag !== `undefined`) {
      console.log(`Tealium is loaded: ${trimmedGaCookieValue()}`)
      
      utag.link({
        "customer_birthdate"     : "",                  //Required
        "customer_email"         : "",                  //Required
        "customer_first_name"    : "",                  //Required
        "customer_id"            : trimmedGaCookieValue(), //Required (RTRIM value of _ga Cookie)
        "customer_last_name"     : "",                  //Required
        "customer_name"          : "",                  //Required
        "customer_phone_number"  : "",                  //Required
        "customer_postal_code"   : ``,   //Required
        "customer_state"         : "",                  //Required
        "customer_type"          : "",                  //Required
        "form_id"                : "",                  //Required
        "form_name"              : "Apply Now Form",          //Required
        "tealium_event"          : "form_complete"      //Required
      });
    }
    else {
      console.log(`Tealium is NOT loaded: ${trimmedGaCookieValue()}`)
    }

    //const search = persistQueryParams({ search: `zipCode=${data.zipCode}` }, location)

    setIsModalOpen(true)
    //location.assign(`${form.destination}?${search}`)
  }

  // On load, focus the form
  React.useEffect(() => {
    
  }, [])

  return (
    <>
        <div className="text-left mt-56 pt-0 mb-10 md:mt-0 md:pt-0 md:mb-0">
          <p className="my-4 text-black font-normal">Our simple membership model provides peace of mind for the whole family, even during life's most testing times. It's how we believe healthcare should be. Join 1.7 million Americans now choosing health sharing as their cost-effective alternative to traditional healthcare.</p>
          <a href="#"onClick={handleSubmit(onSubmit)} className="cursor-pointer bg-background text-black font-semibold rounded-button text-xs border-brandYellow border-2 px-10 py-2 pt-1 text-xl">Apply Now</a>
        </div>
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <h3 className="text-primary font-normal mt-6 mb-0 sm:mb-2 text-center">You're Almost There!</h3>
            <p className="mb-2 md:mb-8 text-primary text-center font-light text-md">Help us get more <span className="underline-red">accurate results.</span></p>
            <BrandedHybridLeadForm form={form} />
        </Modal>
    </>
  )
}

// Simple Modal Component
const Modal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-3xl shadow-lg p-6 w-11/12 max-w-2xl relative border-2 border-gray-700">
        <button
          onClick={onClose}
          className="absolute bg-white p-0.5 top-2 right-2 text-primary focus:outline-none rounded-full border-2 border-solid border-primary"
          aria-label="Close Modal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {children}
      </div>
    </div>
  )
}

export default StraightToModalForm
